<template>
  <div class="zoom-adjuster">
    <div class="zoom-adjuster__input">
      <ui-model-provider v-slot="{ value, updateValue }" :value.sync="computedZoom">
        <ui-range
          type="range"
          :min="$options.MIN_ABSOLUTE_VALUE"
          :max="$options.MAX_ABSOLUTE_VALUE"
          :step="1"
          :value="value"
          required
          @input="updateValue"
        />
      </ui-model-provider>
    </div>
  </div>
</template>

<script>
  import UiModelProvider from '@/components/form/ui-model-provider/ui-model-provider'
  import UiRange from '@/components/form/ui-range/ui-range'
  import { MAP_SCALE_EXTENT } from '@/components/world-map-viewer/util'

  const MIN_ABSOLUTE_VALUE = 0
  const MAX_ABSOLUTE_VALUE = 100
  const MIN_LOG_VALUE = Math.log(MAP_SCALE_EXTENT[0])
  const MAX_LOG_VALUE = Math.log(MAP_SCALE_EXTENT[1])
  const SCALE = (MAX_LOG_VALUE - MIN_LOG_VALUE) / (MAX_ABSOLUTE_VALUE - MIN_ABSOLUTE_VALUE)

  function toLog(value) {
    return Math.exp(MIN_LOG_VALUE + SCALE * (value - MIN_ABSOLUTE_VALUE))
  }

  function toAbs(value) {
    return (Math.log(value) - MIN_LOG_VALUE) / SCALE + MIN_ABSOLUTE_VALUE
  }

  export default {
    components: { UiRange, UiModelProvider },
    props: {
      zoom: {
        type: Number,
        required: true,
      },
    },
    computed: {
      computedZoom: {
        get() {
          const value = toAbs(this.zoom)
          return value
        },
        set(value) {
          this.$emit('update', toLog(value))
        },
      },
    },
    MIN_ABSOLUTE_VALUE,
    MAX_ABSOLUTE_VALUE,
  }
</script>
